{
  "ariaLabel": "Onglets FAA",
  "tabs": {
    "aircraftMapping": "Liaison aéronefs",
    "tailManualAdd": "Ajout immatriculation",
    "blacklist": "Liste noire",
    "tailRequests": "Demandes avion",
    "pendingApprovals": "Approbations en attente"
  },
  "tailMappingTab": {
    "title": "Ajouter un numéro FAA manuellement",
    "description": "Ajouter une nouvelle immatriculation à la base FAA et l'associer à un type d'aéronef. L'immatriculation sera immédiatement disponible pour les chargements en masse et la planification.",
    "form": {
      "labels": {
        "tailNumber": "Immatriculation",
        "manufacturer": "Constructeur",
        "model": "Modèle",
        "aircraft": "Type d'aéronef"
      },
      "placeholders": {
        "tailNumber": "N12345",
        "manufacturer": "CESSNA",
        "model": "172S"
      },
      "buttons": {
        "add": "Ajouter immat.",
        "adding": "Ajout..."
      },
      "validation": {
        "tailNumberRequired": "Immatriculation requise",
        "tailNumberFormat": "Numéro d'immatriculation : lettres, chiffres et tirets uniquement",
        "tailNumberLength": "Numéro d'immatriculation doit contenir entre 2 et 10 caractères",
        "manufacturerRequired": "Fabricant requis",
        "manufacturerLength": "Le fabricant doit contenir entre 2 et 100 caractères",
        "modelRequired": "Le modèle est requis",
        "modelLength": "Le modèle doit contenir entre 1 et 100 caractères",
        "aircraftRequired": "Veuillez sélectionner un type d'aéronef"
      }
    },
    "recentlyAdded": {
      "title": "Immatriculations récemment ajoutées",
      "emptyState": "Aucun numéro de queue ajouté récemment",
      "columns": {
        "tailNumber": "Immatriculation",
        "manufacturer": "Constructeur",
        "model": "Modèle",
        "source": "Source",
        "added": "Ajouté",
        "actions": "Actions"
      },
      "sources": {
        "faaImport": "Importation FAA",
        "justNow": "À l'instant"
      }
    },
    "deleteDialog": {
      "title": "Supprimer l'immat.",
      "confirmationText": "Voulez-vous vraiment supprimer l'immatriculation <strong>{{tailNumber}}</strong> ? Cette action est irréversible.",
      "instructionsText": "Pour confirmer la suppression, veuillez saisir <strong>\"delete\"</strong> dans le champ ci-dessous :",
      "placeholder": "Tapez « delete » pour confirmer",
      "validationError": "Veuillez saisir « delete » exactement",
      "buttons": {
        "cancel": "Annuler",
        "delete": "Supprimer",
        "deleting": "Suppression..."
      }
    },
    "tooltips": {
      "delete": "Supprimer l'immatriculation {{tailNumber}}"
    },
    "messages": {
      "alreadyExists": "Numéro d'immatriculation {{tailNumber}} existe déjà dans la base de données",
      "permissionDenied": "Vous n'avez pas la permission d'ajouter des immatriculations",
      "addFailed": "Échec de l'ajout de l'immatriculation : {{message}}",
      "addSuccess": "Numéro d'immatriculation {{tailNumber}} ajouté avec succès",
      "addSuccessNoMapping": "Immatriculation {{tailNumber}} ajoutée, mais l'association peut nécessiter une révision manuelle",
      "deleteFailed": "Échec de la suppression de l'immatriculation : {{message}}",
      "deleteSuccess": "Numéro d'immatriculation {{tailNumber}} supprimé avec succès",
      "error": "Erreur : {{message}}",
      "unexpectedError": "Une erreur inattendue s'est produite",
      "unexpectedDeleteError": "Une erreur inattendue s'est produite lors de la suppression"
    }
  },
  "suggestedAircraftCell": {
    "confidence": {
      "high": "Élevé",
      "medium": "Moyen",
      "label": "confiance"
    },
    "score": "Score :",
    "tooltip": {
      "matchDetails": "Détails",
      "faaInput": "Entrée FAA (ce que vous mappez) :",
      "suggestedAircraft": "Appareils suggérés :",
      "modelComparison": "Comparaison des modèles :",
      "faa": "FAA :",
      "airplx": "AirPlx :",
      "legend": {
        "match": "✓ trouvé",
        "case": "~ dossier",
        "different": "✗ différent"
      },
      "whyMatch": "Pourquoi ce résultat ?",
      "matchQuality": "Détails qualité correspondance :",
      "verifiedMatch": "✓ Correspondance exacte vérifiée",
      "manufacturer": "Constructeur :",
      "model": "Modèle :",
      "noDirectMatch": "aucune correspondance",
      "scoreLabel": "score",
      "matchLabels": {
        "highMatch": "ok ✓",
        "mediumMatch": "~ corresp.",
        "noMatch": "aucun ✗"
      },
      "otherMatches": "Autres correspondances possibles :",
      "clickAlternative": "Cliquez sur une alternative pour la sélectionner",
      "instructions": "Cliquez sur la coche pour approuver, ou sélectionnez manuellement si incorrect"
    },
    "matchReasons": {
      "csvVerified": "Cette chaîne FAA « {{matchedString}} » a déjà été associée à cet aéronef",
      "csvVerifiedFallback": "Trouvé dans les mappings vérifiés",
      "historical": "Similaire à une correspondance précédente : « {{matchedString}} »",
      "historicalFallback": "Basé sur les tendances historiques de correspondance",
      "combined": "Correspondance trouvée via l'historique et la recherche approximative",
      "traditional": "Correspondance trouvée par recherche approximative du fabricant et du modèle",
      "unknown": "Méthode inconnue"
    }
  }
}
